import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import fr from "../i18n/fr";

i18n.use(initReactI18next).init({
    compatibilityJSON: "v3",
    lng: "fr",
    resources: {
        fr: {
            translation: fr
        }
    },

});

export default i18n;